import { Stack, Typography } from '@mui/material';

import { RHFAutocompleteSelect } from './rhf-autocomplete-select';
import type { RHFAutocompleteProps } from './rhf-autocomplete-select';

type ProductOption = {
  id: string;
  name: string;
  units: string;
  disabled?: boolean;
};

type RHFProductAutocompleteSelectProps = Omit<RHFAutocompleteProps, 'options'> & {
  options: ProductOption[];
};

export function RHFProductAutocompleteSelect({
  options,
  ...other
}: RHFProductAutocompleteSelectProps) {
  return (
    <RHFAutocompleteSelect
      options={options}
      getOptionLabel={(option: any) =>
        option.units ? `${option.name} (${option.units})` : option.name
      }
      renderOption={(props: any, option: any) => {
        const { key, ...otherProps } = props;
        return (
          <li key={key} {...otherProps}>
            <Stack>
              <span>{option.name}</span>
              <Typography variant="body2" color="GrayText">
                {option.units}
              </Typography>
            </Stack>
          </li>
        );
      }}
      {...other}
    />
  );
}
